// extracted by css-extract-rspack-plugin
export default {"metricPill":"ClXXe","metricPillText":"g4GHZ","disabled":"ki0dN","menuTarget":"SUXGG"};